import { render, staticRenderFns } from "./AdminWidget.vue?vue&type=template&id=61b5b0d5"
import script from "./AdminWidget.vue?vue&type=script&lang=ts"
export * from "./AdminWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports